import React from 'react';
import { connect } from 'react-redux'
import Link from '@material-ui/core/Link';
import { Container } from '@material-ui/core';
import Config from "../../config/Configs";

const Footer = ({language}) => {
    const {about,contact,terms,privacy,copyright}= language
    return (
        <footer className="clearfix">
            <Container>
            <div className="footer-left">
            <a href={Config.aboutUrl} rel="noopener noreferrer" target='_blank'>{about} </a>
            <a href={Config.contactUrl} rel="noopener noreferrer" target='_blank'>{contact} </a>
            <a href={Config.termsUrl} rel="noopener noreferrer" target='_blank'>{terms}</a> 
            <a href={Config.privacyUrl} rel="noopener noreferrer" target='_blank'>{privacy}</a></div>
            <div className="footer-right">{copyright}</div>
            </Container>
        </footer>
    )
}
const mapStateToProps = (state) => {
    const {about,contact,terms,privacy,copyright}= state.Language
    return {
        language :{about,contact,terms,privacy,copyright}
    }
}

export default connect(mapStateToProps)(Footer)
